
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 389.404 387.417"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FAAB62","d":"M389.404 330.724c0 31.312-25.383 56.693-56.693 56.693H56.693C25.382 387.417 0 362.036 0 330.724V56.693C0 25.382 25.382 0 56.693 0h276.018c31.311 0 56.693 25.382 56.693 56.693v274.031z"}}),_c('path',{attrs:{"fill":"#F7931E","d":"M387.404 329.317c0 30.989-25.122 56.11-56.111 56.11H58.11c-30.989 0-56.11-25.121-56.11-56.11V58.1C2 27.111 27.122 1.99 58.11 1.99h273.183c30.989 0 56.111 25.122 56.111 56.11v271.217z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M194.485 57.901c-38.593 0-69.878 31.286-69.878 69.878 0 38.593 31.285 69.881 69.878 69.881s69.878-31.288 69.878-69.881c0-38.592-31.285-69.878-69.878-69.878zm0 98.766c-15.953 0-28.886-12.934-28.886-28.887s12.933-28.886 28.886-28.886 28.886 12.933 28.886 28.886-12.933 28.887-28.886 28.887z"}}),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M219.155 253.262c27.975-5.699 44.739-18.947 45.626-19.658 8.186-6.565 9.501-18.523 2.936-26.71-6.564-8.186-18.521-9.501-26.709-2.937-.173.14-18.053 13.856-47.472 13.876-29.418-.02-47.676-13.736-47.849-13.876-8.188-6.564-20.145-5.249-26.709 2.937-6.565 8.187-5.25 20.145 2.936 26.71.899.721 18.355 14.314 47.114 19.879l-40.081 41.888c-7.284 7.554-7.065 19.582.489 26.866a18.936 18.936 0 0013.187 5.322c4.978 0 9.951-1.945 13.679-5.812l37.235-39.665 40.996 39.922c7.428 7.416 19.456 7.404 26.87-.021 7.414-7.426 7.405-19.456-.021-26.87l-42.227-41.851z"}}),_c('path',{attrs:{"d":"M193.536 217.832c-.047 0 .046.001 0 .002-.046-.001.047-.002 0-.002z"}})])])
          )
        }
      }
    